module.exports = __webpack_public_path__ + "img/winthrop_library.a4137fa1.svg";